import GATSBY_COMPILED_MDX from "/opt/build/repo/src/entries/photons.mdx";
import * as React from "react";
import styled from "styled-components";
import {graphql} from "gatsby";
import {Helmet} from "react-helmet";
import {getImage} from "gatsby-plugin-image";
import Title from "../components/title";
import AtlasMDXProvider from "../components/atlas-mdx-provider";
import {AtlasContext} from "../components/atlas-context";
const DivWrapper = (styled.div.attrs({
  className: "atlasWidth"
}))`
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    *zoom: 1;
    display: table;

    @media screen and (min-width: 60em) {
        padding: 1rem;
    }
`;
const Wrapper = (styled.div)`
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;

    @media screen and (min-width: 60em) {
        width: 100%;
        padding: 0;
        float: right;
    }
`;
const EntryWrapper = ({data: {mdx}, children}) => {
  const {frontmatter} = mdx;
  const {title, subtitle, alt, slug} = frontmatter;
  const image = getImage(frontmatter.image);
  return React.createElement(AtlasContext.Provider, {
    value: "entry"
  }, React.createElement(Helmet, null, React.createElement("title", null, "The Quantum Atlas | " + title), React.createElement("meta", {
    property: "og:title",
    content: title
  }), React.createElement("meta", {
    property: "og:description",
    content: subtitle
  }), React.createElement("meta", {
    name: "description",
    content: title + ": " + subtitle
  }), React.createElement("meta", {
    property: "og:image",
    content: image.images.fallback.src
  }), React.createElement("meta", {
    property: "og:image:width",
    content: "1910"
  }), React.createElement("meta", {
    property: "og:image:height",
    content: "1000"
  }), React.createElement("meta", {
    property: "og:url",
    content: "https://quantumatlas.umd.edu" + "/entry/" + slug
  }), React.createElement("meta", {
    property: "og:type",
    content: "article"
  })), React.createElement(DivWrapper, null, React.createElement(Wrapper, null, React.createElement(Title, {
    title: title,
    subtitle: subtitle
  }), React.createElement(AtlasMDXProvider, null, children))));
};
EntryWrapper
export default function GatsbyMDXWrapper(props) {
  return React.createElement(EntryWrapper, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
    query EntryQuery($id: String!) {
        mdx(id: { eq: $id }) {
            frontmatter {
                slug
                title
                subtitle
                image {
                    childImageSharp {
                        gatsbyImageData(width: 200, formats: [AUTO])
                    }
                }
                alt
            }
        }
    }
`;
